import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRdsIcons,
  provideRdsProgressSpinner,
  provideRdsToast,
} from '@rds/angular-components';
import { appRoutes } from './app.routes';
import { apiUrlInterceptor } from './core/interceptors/api-url.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([apiUrlInterceptor, authInterceptor])),
    provideAnimations(),
    provideRdsIcons({ preloadSelected: 'all' }),
    provideRdsProgressSpinner(),
    provideRdsToast({ closeButton: true }),
  ],
};
